<template>
  <div
    style="padding-bottom: 60px"
    :style="{ background: backgroundColor }"
    class="padding-top"
  >
    <div class="container">
      <p class="text-bold text-xxl1 lh-sm">{{ menuCodes["10005"] }}</p>
      <div class="flex justify-between flex-wrap">
        <el-card
          v-for="(item, index) in platformList"
          :key="index"
          style="height: 125px; width: 380px"
          :class="index > 2 ? 'margin-top-sm' : 'margin-top-xs'"
        >
          <el-col :span="8" class="padding-left padding-top"
            ><img :src="item.img"
          /></el-col>
          <el-col :span="14" class="margin-top-sm">
            <p class="text-bold text-lg">{{ item.title }}</p>
            <p class="text-sm text-grey">{{ item.desc }}</p>
          </el-col>
        </el-card>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    backgroundColor: {
      type: String,
      default: "#F6F7F8",
    },
  },
  data() {
    return {
      platformList: [
        {
          img: require("@/assets/platform/icon-1.png"),
          title: "意见建议",
          desc: "向有关行政主管部门反映涉及会员利益的意见建议，维护会员的合法权益。",
        },
        {
          img: require("@/assets/platform/icon-2.png"),
          title: "交流合作",
          desc: "开展物联网服务领域经济技术交流合作。",
        },
        {
          img: require("@/assets/platform/icon-3.png"),
          title: "课题研究",
          desc: "开展物联网服务领域政策的课题研究。",
        },
        {
          img: require("@/assets/platform/icon-4.png"),
          title: "会议服务",
          desc: "组织物联网服务领域的会议、论坛。",
        },
        {
          img: require("@/assets/platform/icon-5.png"),
          title: "咨询服务",
          desc: "提供物联网服务领域信息咨询、政策建议等。",
        },
        {
          img: require("@/assets/platform/icon-6.png"),
          title: "会员培训",
          desc: "开展协会会员内部人才的培训，完善人才培养机制。",
        },
        {
          img: require("@/assets/platform/icon-7.png"),
          title: "展览展示",
          desc: "组织或参加国内外物联网服务领域的各类展览展示。",
        },
        {
          img: require("@/assets/platform/icon-8.png"),
          title: "出版刊物",
          desc: "出版协会内部刊物，包括行业信息、行业动态、政策法规等。",
        },
        {
          img: require("@/assets/platform/icon-9.png"),
          title: "其他事项",
          desc: "承办相关部门委托的其他事项。",
        },
      ],
    };
  },
  computed: {
    menuCodes() {
      return this.$store.state.menuCodes;
    },
  },
};
</script>